import { useEffect, useState } from 'react';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { useAuth } from '../../contexts/AuthContext';

// Select de convênio reutilizável (admissão / edição). value '' = sem convênio.
export const ConvenioSelect = ({ value, onChange, label = 'Convênio', testId = 'select-convenio' }) => {
  const { api } = useAuth();
  const [opcoes, setOpcoes] = useState([]);
  useEffect(() => {
    api.get('/financeiro/convenios/opcoes').then((r) => setOpcoes(r.data || [])).catch(() => setOpcoes([]));
  }, [api]);
  return (
    <div className="space-y-2">
      <Label htmlFor={testId}>{label}</Label>
      <Select value={value || '_none'} onValueChange={(v) => onChange(v === '_none' ? '' : v)}>
        <SelectTrigger id={testId} data-testid={testId}>
          <SelectValue placeholder="Sem convênio" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="_none" data-testid={`${testId}-none`}>Sem convênio</SelectItem>
          {opcoes.map((c) => (
            <SelectItem key={c.id} value={c.id} data-testid={`${testId}-${c.codigo}`}>
              <span className="inline-flex items-center gap-2">
                <span className="h-2.5 w-2.5 rounded-full inline-block" style={{ backgroundColor: c.cor }} />
                {c.nome}
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export const ConvenioTag = ({ nome, cor, className = '' }) => {
  if (!nome) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full border ${className}`}
      style={{ borderColor: cor || '#64748b', color: cor || '#64748b', backgroundColor: `${cor || '#64748b'}14` }}
      title={`Convênio: ${nome}`}
      data-testid="tag-convenio"
    >
      {nome}
    </span>
  );
};
